import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslocoModule } from '@jsverse/transloco';
import { SecurityTipsService } from 'app/modules/shared/services/security-tips.service';

/**
 * The security notes every user is shown once per browser after signing in, in one dialog:
 *  - the device should have device protection; a browser cannot see whether it does (BSI TR-03161-2 O.Plat_1)
 *  - personal data can remain in the device's memory after the app is closed; a web page cannot wipe the
 *    browser's memory (BSI TR-03161-2 O.Plat_7)
 */
@Component({
    selector: 'security-notice-dialog',
    imports: [MatDialogModule, MatButtonModule, TranslocoModule],
    templateUrl: './security-notice-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class SecurityNoticeDialogComponent {
    private _securityTips = inject(SecurityTipsService);

    /** More measures the user can take (BSI O.Plat_8) */
    showTips(): void {
        this._securityTips.open();
    }
}
